<div class="row">
    <div class="col-md-12 col-lg-9">
        <div class="card">
            <div class="card-body">
                <button class="btn btn-primary float-right" (click)="createUser()">Create user</button>
            </div>
        </div>
    </div>
    <div class="col-md-12 col-lg-9">
        <div class="card">
            <div class="card-body">
                <spinner [showSpinner]="isLoading">
                    <div class="table-container">
                        <div class="table-responsive">
                            <table class="table table-hover ">
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>User Name</th>
                                        <th>Access Failed Count</th>
                                        <th>Claims</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr [ngClass]="{'strike': user.isDeleted}" *ngFor="let user of users">
                                        <td>
                                            {{user.id}}
                                        </td>
                                        <td>
                                            {{user.userName}}
                                        </td>
                                        <td>
                                            {{user.accessFailedCount}}
                                        </td>
                                        <td>
                                            {{user.claims.length}}
                                        </td>
                                        <td>
                                            <button type="button" class="btn btn-primary btn-sm mr-1"
                                                [disabled]="user.isDeleted || isBusy"
                                                (click)="openChangePasswordModal(user)">
                                                Change Password
                                            </button>
                                            <button type="button" class="btn btn-primary btn-sm mr-1"
                                                [disabled]="user.isDeleted || user.isAdmin || isBusy"
                                                (click)="makeAdmin(user)">Make admin</button>
                                            <button type="button" class="btn btn-danger btn-sm"
                                                [disabled]="user.isDeleted || isBusy"
                                                (click)="deleteUser(user)">Delete</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </spinner>
            </div>
        </div>
    </div>
</div>